import {
  getCustomTrackingId,
  HashParams,
} from '../../../../analytics-library/getCustomTrackingId/getCustomTrackingId';
import { getRewrittenUrl } from '../../../../analytics-library/getRewrittenUrl';
import type { Deal } from '../../../types/Deal';
import { WidgetType } from '../../../types/WidgetType';
import { Site } from '../../sites/Site';

export const getCustomTrackedOffer = async ({
  deal,
  site,
  articleUrl,
  area,
  battle,
  widgetType,
  link,
  linkText,
  articleName,
  articleType,
  articleCategory,
  social,
  trackingArea,
}: {
  deal: Deal;
  site: Site;
  articleUrl: string;
  area?: string;
  battle?: HashParams['battle'];
  widgetType: WidgetType;
  link?: string;
  linkText?: string;
  articleName: string;
  articleType?: string;
  articleCategory?: string;
  social?: string;
  trackingArea?: string;
}): Promise<Deal> => {
  if (!deal.offer.link) {
    return deal;
  }

  const customTrackingId = await getCustomTrackingId({
    site,
    area,
    articleType,
    articleCategory,
    battle,
    merchantName: deal.merchant.name ?? null,
  });

  // If data-link is set in the placeholder, it has priority over the API deal.offer.link
  const usePlaceholderLink = [WidgetType.DEAL, WidgetType.ANF_DEAL].includes(widgetType) && link;
  const rawLink = usePlaceholderLink ? link : deal.offer.link;

  // If data-link-text is set in the placeholder,
  // it has priority over the API deal.offer.link_text
  const usePlaceholderLinkText = usePlaceholderLink && linkText;
  const offerLinkText = usePlaceholderLinkText ? linkText : deal.offer.link_text;

  return {
    ...deal,
    offer: {
      ...deal.offer,
      ...(offerLinkText && { link_text: offerLinkText }),
      link: getRewrittenUrl({
        url: rawLink,
        site,
        customTrackingId,
        area,
        trackingArea,
        articleUrl,
        articleName,
        social,
      }),
      // Don't rewrite rawLink if it's already set
      ...(!deal.offer.rawLink && { rawLink }),
      custom_tracking_id: customTrackingId,
    },
  };
};
